'use strict';

var $ = require('../internals/export');

var IndexedObject = require('../internals/indexed-object');

var toIndexedObject = require('../internals/to-indexed-object');

var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var nativeJoin = [].join;
var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join

$({
  target: 'Array',
  proto: true,
  forced: ES3_STRINGS || !STRICT_METHOD
}, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});